import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/right_arrow2.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-5d0b1d2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cell-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { class: "operation-box" }
const _hoisted_5 = {
  key: 1,
  src: _imports_0,
  class: "arrow-ico"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "item-box",
        key: index,
        onClick: ($event: any) => (_ctx.handleRouterLink(item, item.key))
      }, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(item.label), 1),
        _createElementVNode("div", _hoisted_4, [
          (item.level === '2')
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(`operation-status ${+item.collect_status > 0 ? 'operation-style' : ''}`)
              }, _toDisplayString(item.status_title), 3))
            : _createCommentVNode("", true),
          (!(item.level === '2' && item.collect_status === '0'))
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : _createCommentVNode("", true)
        ])
      ], 8, _hoisted_2))
    }), 128))
  ]))
}